import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/minisite/components.gallery.scss';
import { Button, Card } from '@weezevent/nacre';
import { Trans } from 'react-i18next';
import Styles from '../../../styles/minisite/minisite.module.css';
import { Icon } from 'semantic-ui-react';
import { usePermissions } from '../../../user/permissions';
import { useHistory } from 'react-router-dom';
import { getMenhirUrl } from '../../../utils/config';

const EventBanner = ({ event, onSelected, organizationId }) => {
    const permissions = usePermissions();
    const history = useHistory();

    const redirectToEventData = React.useCallback(() => {
        if (permissions.hasCapacity('PyvarCapacity.EVENT_CREATE', organizationId)) {
            return history.push(`/ticket/O${organizationId}/E${event.id}/settings/event`);
        } else {
            const menhirUrl = getMenhirUrl();
            if (menhirUrl) {
                return (window.location = `${menhirUrl}/bo/configuration_identite.php?id_evenement=${event.id}`);
            }
        }
    }, [history, permissions, organizationId, event]);

    if (event.full_picture) {
        return (
            <div className={Styles['event-banner']}>
                <div className={Styles['event-banner-description']}>
                    <Trans i18nKey="ticket.event.minisite.event-banner-description" />
                </div>
                <img alt="Event banner" src={event.full_picture} className={Styles['event-banner-image']} />
                <Button inverted primary fluid onClick={() => onSelected('event-banner')}>
                    <Trans i18nKey="ticket.event.minisite.event-banner-cta" />
                </Button>
            </div>
        );
    }

    return (
        <div className={Styles['event-banner-image-empty']}>
            <Card.EmptyState
                icon={<Icon name="list" />}
                title={<Trans i18nKey="ticket.event.minisite.event-banner-empty-title" />}
                subtitle={<Trans i18nKey="ticket.event.minisite.event-banner-empty-text" />}
                labelButton={<Trans i18nKey="ticket.event.minisite.event-banner-empty-cta" />}
                onClick={redirectToEventData}
            />
        </div>
    );
};

EventBanner.propTypes = {
    onSelected: PropTypes.func.isRequired,
    event: PropTypes.any.isRequired
};

export default EventBanner;
